import { css } from '@emotion/react';

import { COLORS2, LAYOUT2, TYPOGRAPHY2 } from '../Styles';

const STATUS_PILL_CONTAINER_STYLE = css`
  label: STATUS_PILL_CONTAINER_STYLE;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  height: ${LAYOUT2.spacing3}px;
  ${TYPOGRAPHY2.xSmallBold}
`;

const STATUS_PILL_CONTAINER_SMALL_STYLE = css`
  label: STATUS_PILL_CONTAINER_SMALL_STYLE;
  ${TYPOGRAPHY2.xxSmallBold}
  height: ${LAYOUT2.spacing2}px;
`;

const STATUS_PILL_PART_STYLE = css`
  label: STATUS_PILL_PART_STYLE;
  display: inline-flex;
  align-items: center;
  padding: 0 ${LAYOUT2.spacing2}px;
  height: 100%;
  text-transform: uppercase;
  white-space: nowrap;
  border: 1px solid;
`;

const STATUS_PILL_PART_TIGHT_STYLE = css`
  label: STATUS_PILL_PART_TIGHT_STYLE;
  display: inline-flex;
  align-items: center;
  padding: 0 ${LAYOUT2.spacing1}px;
  height: 100%;
  text-transform: uppercase;
  white-space: nowrap;
  border: 1px solid;
`;

const STYLES_BY_COLOR = {
  green: {
    background: COLORS2.namedColors.green,
    text: COLORS2.namedColors.white,
    border: COLORS2.namedColors.green,
    textOnWhite: COLORS2.namedColors.green,
  },
  blue: {
    background: COLORS2.namedColors.blue,
    text: COLORS2.namedColors.white,
    textOnWhite: COLORS2.namedColors.darkishBlue,
    border: COLORS2.namedColors.blue,
  },
  yellow: {
    background: COLORS2.namedColors.yellow,
    text: COLORS2.namedColors.black,
    border: COLORS2.namedColors.yellow,
    textOnWhite: COLORS2.namedColors.yellow,
  },
  red: {
    background: COLORS2.namedColors.red,
    text: COLORS2.namedColors.white,
    border: COLORS2.namedColors.red,
    textOnWhite: COLORS2.namedColors.red,
  },
  gray: {
    background: COLORS2.namedColors.gray,
    text: COLORS2.namedColors.black,
    border: COLORS2.namedColors.gray,
    textOnWhite: COLORS2.namedColors.darkGray,
  },
  darkYellow: {
    background: COLORS2.namedColors.darkYellow,
    text: COLORS2.namedColors.white,
    border: COLORS2.namedColors.darkYellow,
    textOnWhite: COLORS2.namedColors.darkYellow,
  },
  darkBlue: {
    background: COLORS2.namedColors.darkBlue,
    text: COLORS2.namedColors.white,
    border: COLORS2.namedColors.darkBlue,
    textOnWhite: COLORS2.namedColors.darkBlue,
  },
  charcoal: {
    background: COLORS2.namedColors.charcoal,
    text: COLORS2.namedColors.white,
    border: COLORS2.namedColors.charcoal,
    textOnWhite: COLORS2.namedColors.charcoal,
  },
  darkGray: {
    background: COLORS2.namedColors.darkerGray,
    text: COLORS2.namedColors.white,
    border: COLORS2.namedColors.darkerGray,
    textOnWhite: COLORS2.namedColors.darkGray,
  },
  darkGreen: {
    background: COLORS2.namedColors.darkGreen,
    text: COLORS2.namedColors.white,
    border: COLORS2.namedColors.darkGreen,
    textOnWhite: COLORS2.namedColors.darkGreen,
  },
  darkOrange: {
    background: COLORS2.namedColors.darkOrange,
    text: COLORS2.namedColors.white,
    border: COLORS2.namedColors.darkOrange,
    textOnWhite: COLORS2.namedColors.darkOrange,
  },
};
export type StatusColor = keyof typeof STYLES_BY_COLOR;

export const StatusPill = ({ statusTypeText, statusText, color, small, tight }: {
  statusTypeText?: string;
  statusText?: string;
  color?: keyof typeof STYLES_BY_COLOR;
  small?: boolean;
  tight?: boolean;
}) => {
  const partStyle = tight ? STATUS_PILL_PART_TIGHT_STYLE : STATUS_PILL_PART_STYLE;
  const colors = STYLES_BY_COLOR[color ?? 'gray'];

  return (
    <div css={[STATUS_PILL_CONTAINER_STYLE, small && STATUS_PILL_CONTAINER_SMALL_STYLE]}>
      {statusTypeText && (
        <span
          css={[
            partStyle,
            css`
        label: STATUS_TYPE_CSS;
        background: ${colors.background};
        color: ${colors.text};
        border-color: ${colors.border};
      `,
          ]}
        >
          {statusTypeText}
        </span>
      )}

      {statusText && (
        <span
          css={[
            partStyle,
            css`
        label: STATUS_CSS;
        background: ${COLORS2.namedColors.white};
        color: ${colors.textOnWhite ?? colors.background};
        border-color: ${colors.border};
        border-left: ${statusTypeText ? 'none' : '1px solid'};
      `,
          ]}
        >
          {statusText}
        </span>
      )}
    </div>
  );
};
